import { cn } from '@/lib/utils'
import React from 'react'
import { motion } from 'motion/react'

export const BackgroundGradient = ({
  children,
  className,
  containerClassName,
  animate = true
}: {
  children?: React.ReactNode
  className?: string
  containerClassName?: string
  animate?: boolean
}) => {
  const variants = {
    initial: {
      backgroundPosition: '0 50%'
    },
    animate: {
      backgroundPosition: ['0, 50%', '100% 50%', '0 50%']
    }
  }

  // Define the gradient string using Tailwind v4 CSS variables
  const backgroundImage = `
    radial-gradient(circle farthest-side at 0 100%, var(--color-emerald-300), transparent), 
    radial-gradient(circle farthest-side at 100% 0, var(--color-amber-500), transparent), 
    radial-gradient(circle farthest-side at 100% 100%, var(--color-blue-400), transparent), 
    radial-gradient(circle farthest-side at 0 0, var(--color-amber-400), #141316)
  `

  return (
    <div className={cn('group relative p-0.5', containerClassName)}>
      <motion.div
        variants={animate ? variants : undefined}
        initial={animate ? 'initial' : undefined}
        animate={animate ? 'animate' : undefined}
        transition={
          animate
            ? {
                duration: 5,
                repeat: Infinity,
                repeatType: 'reverse'
              }
            : undefined
        }
        style={{
          backgroundSize: animate ? '400% 400%' : undefined,
          backgroundImage: backgroundImage
        }}
        className={cn(
          'absolute inset-0 z-[1] rounded-lg opacity-60 blur-xl transition duration-500 will-change-transform group-hover:opacity-100'
        )}
      />
      <motion.div
        variants={animate ? variants : undefined}
        initial={animate ? 'initial' : undefined}
        animate={animate ? 'animate' : undefined}
        transition={
          animate
            ? {
                duration: 5,
                repeat: Infinity,
                repeatType: 'reverse'
              }
            : undefined
        }
        style={{
          backgroundSize: animate ? '400% 400%' : undefined,
          backgroundImage: backgroundImage
        }}
        className={cn(
          'absolute inset-0 z-[1] rounded-lg will-change-transform'
        )}
      />

      <div className={cn('relative z-10', className)}>{children}</div>
    </div>
  )
}
